import React from "react";
import cogoToast from "cogo-toast";
// import Explanation from "../modals/Explanation";

class QuizBubble extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      error: "",
      optionSelected: "",
      quiz_data: {
        quiz_title: ""
      },
      question_list: {
        question_title: "",
        question_media: [
          {
            media_path: ""
          }
        ],
        question_options: [
          {
            option_name: "",
            question_option_id: ""
          }
        ]
      },
      ans: [],
      attempts: 0,
      rightAns: "none",
      wrongAns: "none",
      date: 0
    };
  }

  componentDidMount() {
    this.setState({ question_list: this.props.unitDetails });
    this.setState({
      start: this.state.date
    });

    this.timerID = setInterval(() => this.tick(), 1000);
  }
  tick() {
    this.setState({ date: this.state.date + 1 });
  }
  componentWillMount() {
    this.setState({ question_list: this.props.unitDetails });
  }
  componentWillUnmount() {
    clearInterval(this.timerID);
  }
  tick() {
    this.setState({ date: this.state.date + 1 });
  }
  onOptionSelection = event => {
    this.setState({ attempts: this.state.attempts + 1 });
    this.setState({ error: "" });

    this.setState({ optionSelected: event.target.id });
    const allBubbles = document.querySelectorAll(".bubble");

    // event.target.classList.remove('moveclouds')
    event.target.classList.add("pause");
    event.target.classList.add("puff-out-center");

    if (event.target.id == 1) {
      // this.setState({ rightAns: "block", wrongAns: "none" });

      for (let i = 0; i < allBubbles.length; i++) {
        allBubbles[i].classList.add("disabled");
      }
      cogoToast.success("Correct", { position: "top-center" });
      // type: "error",
      //   text: "Try  Again !"
      this.props.playCorrectAudio();
      // setTimeout(() => {
      //   this.nextque();
      //   for (let i = 0; i < allBubbles.length; i++) {
      //     allBubbles[i].classList.remove("disabled");
      //     allBubbles[i].classList.remove("pause");
      //     allBubbles[i].classList.remove("puff-out-center");
      //   }
      // }, 3500);

      let obj = {};
      obj.quiz_unit_id = this.state.quiz_data.quiz_unit_id;
      obj.course_unit_id = this.props.Details.course_unit_id;
      obj.coursemaster_id = this.props.Details.coursemaster_id;
      obj.question_id = this.props.unitDetails.main_question_id;
      obj.start_time = this.state.start;
      obj.no_of_attempted = this.state.attempts;
      obj.total_point = 5;
      obj.answer_id = this.props.unitDetails.question_options[0].option_id;
      obj.obtained_score = this.state.quiz_data.marks_for_correct_answer;
      obj.accuracy =
        (100 * this.state.quiz_data.marks_for_correct_answer) /
        this.state.quiz_data.marks_for_correct_answer;
      obj.obtained_point = 5;
      obj.time_spent_duration =
        parseInt(this.state.date) - parseInt(this.state.start);
      obj.total_score = this.state.quiz_data.marks_for_correct_answer;
      obj.end_time = this.state.date;
      if (localStorage.getItem("quiz")) {
        var scores = JSON.parse(localStorage.getItem("quiz"));
        var exist = false;
        for (let i = 0; i < scores.length; i++) {
          if (obj.question_id == scores[i].question_id) {
            scores[i] = obj;
            exist = true;
            localStorage.setItem("quiz", JSON.stringify(scores));
          }
        }
        if (!exist) {
          var cart = [];
          cart = JSON.parse(localStorage["quiz"]);
          cart.push(obj);
          localStorage.setItem("quiz", JSON.stringify(cart));
        }
      } else {
        var arra = [];
        arra.push(obj);
        console.log(arra);
        localStorage.setItem("quiz", JSON.stringify(arra));
      }

      var a = {};
      a.answer = "Correct";
      a.text = this.props.unitDetails.correct_feedback;
      a.video = this.props.unitDetails.correct_feedback_video;
      this.setState({ open: true, explain_data: a });
      // document.querySelector('.next-btn').classList.remove('disable')
    } else {
      // this.setState({ rightAns: "none", wrongAns: "block" });
      cogoToast.error("Wrong", { position: "top-center" });
      this.props.playIncorrectAudio();

      for (let i = 0; i < allBubbles.length; i++) {
        allBubbles[i].classList.add("disabled");
      }

      // setTimeout(() => {
      //   this.nextque();
      //   for (let i = 0; i < allBubbles.length; i++) {
      //     allBubbles[i].classList.remove("disabled");
      //     allBubbles[i].classList.remove("pause");
      //     allBubbles[i].classList.remove("puff-out-center");
      //   }
      // }, 3500);

      var a = {};
      a.answer = "Wrong";
      a.text = this.props.unitDetails.incorrect_feedback;
      a.video = this.props.unitDetails.incorrect_feedback_video;
      this.setState({ open: true, explain_data: a });
    }
  };

  nextque = () => {
    this.props.parentMethod();
  };
  onOpenModal_Explain = () => {
    this.setState({ open: true });
  };
  onCloseModal_Explain = () => {
    this.setState({ open: false });

    const allRadioButtons = document.querySelectorAll(".radio-button");
    for (let i = 0; i < allRadioButtons.length; i++) {
      allRadioButtons[i].classList.add("disabled");
    }
    setTimeout(() => {
      const allBubbles = document.querySelectorAll(".bubble");
      this.nextque();
      for (let i = 0; i < allBubbles.length; i++) {
        allBubbles[i].classList.remove("disabled");
        allBubbles[i].classList.remove("pause");
        allBubbles[i].classList.remove("puff-out-center");
      }
    }, 100);
  };
  render() {
    return (
      <div className="bubble-quiz-boxn text-center">
        <div className="rounded">
          <div className="heading-block">
            <p
              className="text-4 text-black m-0 question-quiz"
              id="question_title"
              dangerouslySetInnerHTML={{
                __html: this.props.unitDetails.question_title
              }}
            ></p>
          </div>
          <div className="modal-body bubble-body mx-auto border-top border-bottom">
            <div id="bubbles" className="inner-game-container ">
              {this.props.unitDetails.question_options !== null &&
              this.props.unitDetails.question_options !== undefined &&
              this.props.unitDetails.question_options !== [] &&
              this.props.unitDetails.question_options.length > 0
                ? this.props.unitDetails.question_options.map(
                    (option, key) => (
                      <div>
                        <div
                          onClick={this.onOptionSelection.bind(this)}
                          id={option.right_answer}
                          className={`bubble x${key +
                            1} d-flex justify-content-center align-items-center shadow moveclouds`}
                        >
                          {option.option_name}
                        </div>
                      </div>
                    )
                  )
                : ""}
            </div>
          </div>

          <div className="row d-flex justify-content-center my-3 next-btn"></div>
        </div>
        {/* <Explanation
          explain_data={this.state.explain_data}
          open={this.state.open}
          close={this.onCloseModal_Explain}
        /> */}
      </div>
    );
  }
}
export default QuizBubble;
